export default "__VITE_ASSET__CvCRC4kw__"